//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('productSuggestionsFeedbackForm', {
    bindings: {
      itemId: '@',
      boxId: '@',
      feedbackGiven: '&',
    },
    template: require('@legacy-components/intelligent-product-tagging/product-suggestions-feedback-form.html'),
    controller: [
      '$timeout',
      'AssistedProductTaggingService',
      'TrackingService',
      'UniversalImageActionsHelpers',
      'UniversalImageActionsService',
      function(
                $timeout,
                AssistedProductTaggingService,
                TrackingService,
                UniversalImageActionsHelpers,
                UniversalImageActionsService,
            ) {
        const self = this;
        let feedbackSent = false;
        const FEEDBACK_SENT_STRING_CHANGE_DELAY = 200;
        const FEEDBACK_SENT_HIDE_DELAY = 500;
        const TRACKING_CATEGORY = UniversalImageActionsHelpers.getTrackingCategory(UniversalImageActionsService.getCurrentPage());

        self.saveFeedback = function(thumbsUp) {
          if (feedbackSent) {
            return;
          }

          TrackingService.recordEvent(TRACKING_CATEGORY, TrackingService.ACTION_RATE_PRODUCT_SUGGESTIONS, thumbsUp.toString());
          AssistedProductTaggingService.saveFeedbackAsync(self.itemId, self.boxId, thumbsUp);
          feedbackSent = true;

          $timeout(() => {
            self.showFeedbackSent = true;

            $timeout(() => {
              self.feedbackGiven({ feedbackGivenStatus: true });
            }, FEEDBACK_SENT_HIDE_DELAY);
          }, FEEDBACK_SENT_STRING_CHANGE_DELAY);
        };
      },
    ],
  });
})();
